module.exports = __webpack_public_path__ + "static/media/country_pk.9d8848f0.webp";